import values from 'lodash/values'

export const GET_ALL_KITCHEN_DEPARTMENTS = 'GET_ALL_KITCHEN_DEPARTMENTS'
export const OPEN_KITCHEN_DEPARTMENT_SELECTION = 'OPEN_KITCHEN_DEPARTMENT_SELECTION'
export const CLOSE_KITCHEN_DEPARTMENT_SELECTION = 'CLOSE_KITCHEN_DEPARTMENT_SELECTION'
export const TOGGLE_KITCHEN_DEPARTMENT_SELECTION = 'TOGGLE_KITCHEN_DEPARTMENT_SELECTION'
export const TOGGLE_ALL_KITCHEN_DEPARTMENT_SELECTION = 'TOGGLE_ALL_KITCHEN_DEPARTMENT_SELECTION'
export const SAVE_KITCHEN_DEPARTMENT_SELECTION = 'SAVE_KITCHEN_DEPARTMENT_SELECTION'
export const GET_SELECTED = 'GET_SELECTED'

export const getAllKitchenDepartments = (payload) => {
  return (dispatch, getState) => {
    dispatch({
      type: GET_ALL_KITCHEN_DEPARTMENTS,
      payload
    })
  }
}

export const openKitchenDepartmentSelection = (storeId, {selected, params }) => {
  return (dispatch, getState) => {
    const department = getState().forms.kitchenDepartmentSelection.all
    dispatch({ type: OPEN_KITCHEN_DEPARTMENT_SELECTION, all: values(department), selected: selected.slice(), params });
  }
}

export const toggleAllKitchenDepartmentSelection = (checked) => {
  return (dispatch, getState) => {
    dispatch({ type: TOGGLE_ALL_KITCHEN_DEPARTMENT_SELECTION, checked});
  }
}

export const closeKitchenDepartmentSelection = () => ({ type: CLOSE_KITCHEN_DEPARTMENT_SELECTION });

export const toggleKitchenDepartmentSelection = (id,checked) => ({type: TOGGLE_KITCHEN_DEPARTMENT_SELECTION, id,checked });

export const submitKitchenDepartmentSelection = (openerSubmitCallback) => {
  return (dispatch, getState) => {
    const state = getState();
    const { selected, params } = state.forms.kitchenDepartmentSelection;
    dispatch({ type: SAVE_KITCHEN_DEPARTMENT_SELECTION, selected, params });
    if (typeof openerSubmitCallback === 'function') {
      openerSubmitCallback();
    }
  }
}



/** WEBPACK FOOTER **
 ** ./client/actions/formActions/kitchenDepartmentSelection.js
 **/